module.exports = __webpack_public_path__ + "static/media/new-date.ae3cf566.svg";